import { ContactCard, EContactCardLayout } from "@organic-return/foundation-react/src/components/Contact"
import { EWsrvTransform, IPerson } from "@organic-return/foundation-react/src/lib"
import React from "react"

const BiographyBlade = ({ module }) => {
    const { title, biography, headshot, headshotSize } = module.customFields
    const person: IPerson = {
        fullName: title,
        bio: biography,
        photos: headshot && [{
            url: headshot.url,
            dimensions: headshot.width && headshot.height ? [headshot.width, headshot.height] : undefined,
        }]
    }
    return (
        <section className="biography-blade relative w-full py-24 lg:py-36">
            <ContactCard
                className="relative max-w-screen-xl mx-auto"
                contact={person}
                layout={EContactCardLayout.pageSection}
                showBio={true}
                showVCard={false}
                showAgentBioReadMoreButton={false}
                imageWsrvTransform={headshotSize === "1x1" ? EWsrvTransform.thumb1x1 : EWsrvTransform.thumb3x4}
                imageClasses="!max-w-none !min-h-0 w-full"
                imageProps={{
                    style: {}
                }}
            ></ContactCard>
        </section>
    )
}

export default BiographyBlade